/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-toolkit-page-title',
    templateUrl: './page-title.component.html',
    styleUrls: [
        './page-title.component.scss'
    ],
})
export class SharedToolkitPageTitleComponent {

    @Input() title: string = '';
    @Input() subTitle: string;

}
